import { makeAutoObservable } from "mobx";
import { Availability } from "../ordering";
export class BlikCodeState {
    constructor() {
        this._value = "";
        this._serverErrors = [];
        makeAutoObservable(this);
    }
    updateValue(v) {
        this._value = v;
        this._serverErrors = [];
    }
    get serverErrors() {
        return this._serverErrors;
    }
    setServerErrors(errors) {
        this._serverErrors = errors;
    }
    clearServerErrors() {
        this._serverErrors = [];
    }
    get availability() {
        return Availability.boolean({
            InvalidBlikCode: this._serverErrors.length === 0 && !/^\d{6}$/.test(this._value),
            BlikCodeServerError: this.serverErrors.length > 0,
        });
    }
}
